import { Box, css } from '@mui/material'
import { useMQ } from '../hooks/useMQ'

export function HeroText() {
  const { isXsSize, isSmSize, isMdSize } = useMQ()

  const getWrapperStyle = () => {
    if (isSmSize) {
      return css`
        margin-top: 50px;
      `
    }
    if (isMdSize) {
      return css`
        margin-top: 75px;
      `
    }
  }

  const getTitleStyle = () => {
    if (isXsSize) {
      return css`
        font-size: 40px;
        line-height: 50px;
      `
    }
    if (isSmSize) {
      return css`
        font-size: 60px;
        line-height: 80px;
      `
    }

    return css`
      font-size: 80px;
      line-height: 100px;
    `
  }

  const getDescriptionStyle = () => {
    if (isXsSize) {
      return css`
        margin-top: 20px;
        font-size: 20px;
        line-height: 24px;
      `
    }
    if (isSmSize) {
      return css`
        font-size: 24px;
        line-height: 40px;
        max-width: 500px;
      `
    }

    return css`
      font-size: 30px;
      line-height: 48px;
    `
  }

  const styles = {
    wrapper: css`
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 1;
      position: relative;
      margin-top: 100px;
      ${getWrapperStyle()}
    `,
    title: css`
      font-family: 'Red-Hat-Display';
      text-align: center;
      text-shadow: 0px 0px 250px rgba(255, 255, 255, 0.25);
      font-weight: 700;
      background: linear-gradient(90deg, #fff 36%, #999 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      ${getTitleStyle()}
    `,
    description: css`
      margin: 12px;
      max-width: 780px;
      color: #cecece;
      font-weight: 400;
      ${getDescriptionStyle()}
    `,
  }

  return (
    <Box css={styles.wrapper}>
      <Box css={styles.title} className='fade-in-up'>
        The first PayFi Network
      </Box>
      <Box css={styles.description} className='fade-in-up-delay'>
        Huma accelerates global payments with instant access to liquidity
        anywhere, anytime.
      </Box>
    </Box>
  )
}
